import { useState } from 'react';
import { getItemFromStore, setItemToStore } from '../helpers/utils';

export const TABLE_PAGE_SIZE_OPTIONS = [20, 50, 100, 200, 500, 1000];
const TABLE_PAGE_SIZE_KEY = 'med_table_page_size';
const DEFAULT_TABLE_PAGE_SIZE = 20;

const normalizePageSize = value => {
  const numericValue = Number(value);
  return TABLE_PAGE_SIZE_OPTIONS.includes(numericValue) ? numericValue : DEFAULT_TABLE_PAGE_SIZE;
};

export const getStoredTablePageSize = () =>
  normalizePageSize(getItemFromStore(TABLE_PAGE_SIZE_KEY, DEFAULT_TABLE_PAGE_SIZE));

const useStoredTablePageSize = () => {
  const [pageSize, setPageSizeState] = useState(getStoredTablePageSize);

  const setPageSize = value => {
    const normalizedValue = normalizePageSize(value);
    setPageSizeState(normalizedValue);
    setItemToStore(TABLE_PAGE_SIZE_KEY, normalizedValue);
  };

  return [pageSize, setPageSize];
};

export default useStoredTablePageSize;
